import styled from "@emotion/styled";

export const CellContainer = styled.div(() => ({
    display: "flex",
    alignItems: "center",
    height: "100%",
}));

export const RadioContainer = styled.div(() => ({
    marginRight: "8px",
}));

export const TableWrapper = styled.div(() => ({
    marginBottom: "12px",
}));
